import { render, staticRenderFns } from "./lookApply.vue?vue&type=template&id=4884d73c&scoped=true&"
import script from "./lookApply.vue?vue&type=script&lang=js&"
export * from "./lookApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884d73c",
  null
  
)

export default component.exports